import { ComponentProps } from 'react';
import { useTranslation } from 'react-i18next';
import clsx from 'clsx';
import { useDispatch } from 'react-redux';

import { changeRoute } from 'routes/AuthenticatedContainer/actions';

import { OpTextButton } from '../OpTextButton/OpTextButton';

interface OpLinkProps
  extends Omit<ComponentProps<typeof OpTextButton>, 'title' | 'onClick'> {
  route: string;
}

/**
 * OpLink is a custom link component built on OpTextButton for internal navigation.
 * It provides navigation within the application using Redux routing.
 * 
 * Use this component for internal navigation links that need to dispatch route changes
 * through Redux. Styled as a text button with accessibility support.
 * 
 * @example
 * <OpLink route="/users">Go to Users</OpLink>
 * 
 */
export const OpLink = ({
  className,
  children,
  route,
  ...buttonProps
}: OpLinkProps) => {
  const { t } = useTranslation();
  const dispatch = useDispatch();

  return (
    <OpTextButton
      className={clsx('op-link', className)}
      {...buttonProps}
      title={t('(Changes page)')}
      onClick={() => dispatch(changeRoute(route))}
    >
      {children}
    </OpTextButton>
  );
};
